export const WINDOW_IS_SEARCH_BOT_FLAG: string = '__IS_SEARCH_BOT__';

export const SEARCH_BOT_FLAG_SCRIPT: string = `<script>window.${WINDOW_IS_SEARCH_BOT_FLAG}=true</script>`;

export const SEARCH_BOT_META_NAME: string = 'lu-is-search-bot';

export const SEARCH_BOT_META_CONTENT: string = 'true';

export const SEARCH_BOT_META_TAG: string = `<meta name="${SEARCH_BOT_META_NAME}" content="${SEARCH_BOT_META_CONTENT}">`;

export const SEARCH_BOT_FLAG_MARKERS: string = SEARCH_BOT_FLAG_SCRIPT + SEARCH_BOT_META_TAG;
